import { findMessageIndex } from '../../lib';
import { MessageListItem } from '../../types';
import * as Validations from './MessageList.validations';

function add (messages: MessageListItem[], ...newItems: MessageListItem[]) {
  if (!newItems.length) return messages;
  Validations.validate('[MessageList] Some of the new items already exists', () => Validations.shouldNotExists(messages, ...newItems));
  return messages.concat(newItems);
}

function remove (messages: MessageListItem[], ...itemsToRemove: MessageListItem[]) {
  const idsToRemove = new Set(itemsToRemove.map(i => i.id));
  const next = messages.filter(m => !idsToRemove.has(m.id));
  // if no items are removed, return reference to original.
  return next.length === messages.length ? messages : next;
}

function addAt (messages: MessageListItem[], index: number, ...itemsToAdd: MessageListItem[]) {
  if (!itemsToAdd.length) return messages;
  Validations.validate('[MessageList] Some of the new items already exists', () => Validations.shouldNotExists(messages, ...itemsToAdd));
  return [
    ...messages.slice(0, index),
    ...itemsToAdd,
    ...messages.slice(index),
  ];
}

function clear () {
  return [];
}

function update (messages: MessageListItem[], updatedItem: MessageListItem) {
  if (!updatedItem) return messages;
  Validations.validate('[MessageList:update] The item does not exists', () => Validations.shouldExists(messages, updatedItem));
  const index = findMessageIndex(messages, updatedItem);
  const nextMessages = [...messages];
  nextMessages[index] = updatedItem;
  return nextMessages;
}

/**
 * Appends given messages. If the messages to append exists in the given messageList,
 * then those will be removed first.
 */
function addSafe (messages: MessageListItem[], ...itemsToAppend: MessageListItem[]) {
  if (!itemsToAppend.length) return messages;
  return add(remove(messages, ...itemsToAppend), ...itemsToAppend);
}

export const MessageListApi = { add, remove, addAt, clear, update, addSafe };
